import {
  UseMutationOptions,
  keepPreviousData,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { AxiosError } from "axios"

import { ProductResponses } from "@tfg/types/endpoints/products"
import { getProductsRdueValidationType } from "@tfg/types/schemas/products"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useProductsRDUEQuery = ({
  fetchDataOptions,
  filters,
}: getProductsRdueValidationType) =>
  useQuery({
    queryKey: ["products", "rdue", fetchDataOptions, filters],

    queryFn: async () => {
      const res = await httpClient.get<ProductResponses.GetRDUEProducts>(
        `products-rdue`,
        {
          params: {
            fetchDataOptions,
            filters,
          },
        }
      )
      return res.data
    },

    placeholderData: keepPreviousData,
  })

export const useValidateProductMutation = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    {
      ids: number[]
    }
  >
) =>
  useMutation({
    ...options,
    mutationFn: async (variables) =>
      await httpClient.post<{ ids: number[] }>(
        `products-rdue/validate`,
        variables
      ),

    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({ queryKey: ["products", "rdue"] })
    },
  })

export const useSyncProductsMutation = (
  options?: UseMutationOptions<number, AxiosError, unknown>
) =>
  useMutation({
    ...options,
    mutationFn: async () =>
      (await httpClient.put(`products-rdue/sync-status`)).data,

    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({ queryKey: ["products", "rdue"] })
    },
  })
